// extracted by mini-css-extract-plugin
export default {"features":"Features_features__NIUmn","content":"Features_content__g4rc1","cardArea":"Features_cardArea__hNAfk"};